import { get } from "lodash";

export const getParticipantId = (item: any) => get(item, "participant_id", get(item, "id", ""));

export const getMessage = (message: any, language?: string, fallback = "Success") => {
  if (!message) return fallback;
  if (typeof message === "string") return message;
  return message[language ?? "en"] ?? message.en ?? message.vi ?? fallback;
};
